import { isDocumentReopen } from './documentNavigation';
import type { NavPathState } from './navPath';

/** history.state 를 못 읽는 환경(테스트 등)에서 쓰는 한 칸짜리 key. */
const NO_HISTORY_KEY = 'no-history-key';

export function readHistoryKey(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const historyState = window.history.state as { key?: unknown } | null;
  return typeof historyState?.key === 'string' ? historyState.key : undefined;
}

export const currentHistoryKey = () => readHistoryKey() ?? NO_HISTORY_KEY;

/**
 * 길을 찾을 key. Next 는 문서 로드 때 지금 항목의 key 를 새로 바꾸므로, 다시 연 문서(`isDocumentReopen`)에서
 * 아직 기록 전이고 지금 key 의 길이 없으며 `lastShownKey` 의 길이 지금 주소에서 끝나면 그 key 를 쓴다.
 */
export function entryKey(
  state: NavPathState,
  asPath: string,
  key: string = currentHistoryKey(),
  reopened: boolean = isDocumentReopen(),
): string {
  const last = state.lastShownKey;
  const isReopenedEntry =
    reopened &&
    state.currentKey === null &&
    !state.paths[key] &&
    last !== null &&
    state.paths[last]?.at(-1)?.href === asPath;
  return isReopenedEntry ? last : key;
}

/** 다시 연 항목의 길을 새 key 에도 옮겨 둔다. 기록할 때만 쓴다. */
export function adoptReloadedEntry(
  state: NavPathState,
  asPath: string,
): NavPathState {
  const key = currentHistoryKey();
  const resolvedKey = entryKey(state, asPath, key);
  const path = state.paths[resolvedKey];
  if (resolvedKey === key || !path) return state;
  return { ...state, paths: { ...state.paths, [key]: path } };
}
